import { createContext, useContext } from 'react';

export const TableStateContext = createContext(null);
export const UseTableState = () => useContext(TableStateContext);